import React, { useState } from "react"
import { Space, Button } from "antd"
import dayjs from "dayjs"

import Markdown from "@components/Markdown"
import { Modal } from "@components/Page"
import { W0, W1 } from "@components/constants"
import { getCurrencyValue } from "@helpers/formats"

const LABEL_OK = "I UNDERSTAND"
const LABEL_TITLE = "Send Funds"
const LABEL_CONTENT = `You have selected to send in your investment funds
through a linked bank account. Once you click "Send Funds", a confirmation
window will pop up to confirm the amount you would like to invest.

Click the blue "Send [AMOUNT]" to initiate the transfer.

Your investment amount will be electronically transferred through ACH from your
bank account. This means that the funds are pulled from your account within 1-2
business days and are received by your Sponsor within an additional 3-5 business
days. The total time to transfer the funds should take 4-7 business days in
total (not including holidays and weekends).

If you send funds today, your funds will most likely arrive by [DATE].`


const ConfirmationModal = ({ modal, investment }) => {
  const [ isOpen, setIsOpen ] = useState(false)

  modal.current.open = () =>
    setIsOpen(true)

  const onClose = () =>
    setIsOpen(false)

  const {
    totalAmount,
    receivedAmount,
    isPartiallyFunded,
  } = investment

  const amount = isPartiallyFunded
    ? totalAmount - receivedAmount
    : totalAmount

  const currencyAmount = getCurrencyValue(amount)

  const content = LABEL_CONTENT
    .replace('[AMOUNT]', currencyAmount)
    .replace('[DATE]', dayjs().add(9, 'day').format('MM/DD/YYYY'))

  return (
    <Modal
      title={LABEL_TITLE}
      isOpen={isOpen}
      onClose={onClose}
    >
      <Space direction="vertical" style={{ marginTop: -1 * W1, marginBottom: W0 }}>
        <Markdown text={content} />
        <center>
          <Button
            type="primary"
            onClick={onClose}
          >
            {LABEL_OK}
          </Button>
        </center>
      </Space>
    </Modal>
  )
}

export default ConfirmationModal
